import * as React from 'react';
import { createStore } from './core.js';
import { registerStore } from './registry.js';
import { useSyncExternalStore } from './external-store-hook.js';

export function createRestateApi(store, kind = 'memory') {
    function useRestate() {
        const snapshot = useSyncExternalStore(
            store.subscribe,
            store.get,
            store.get
        );
        React.useDebugValue(snapshot);
        return snapshot;
    }

    Object.assign(useRestate, {
        id: store.id,
        kind,
        get: store.get,
        getInitial: store.getInitial,
        set: store.set,
        reset: store.reset,
        subscribe: store.subscribe,
        on: store.on,
        listenerCount: store.listenerCount,
        isRunning: store.isRunning,
        start: store.start,
        stop: store.stop,
        destroy() {
            try {
                useRestate.__removeFromRegistry?.();
            } finally {
                store.destroy();
            }
        },
        __store: store,
    });

    store.setEventTarget(useRestate);

    return useRestate;
}

export function restate(initialValue, updater) {
    const store = createStore(initialValue, updater);
    return registerStore(createRestateApi(store));
}
